import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getChannel, isTelusTheme } from 'utils/getChannel';
import { small } from '../utils';
import UnmindLogo from '../Shared/Assets/unmind_logo_with_name.svg';
import TelusLogo from '../Shared/Assets/telus_logo.svg';

const Logo = styled.img`
  flex-shrink: 0;
  z-index: 1;
  position: absolute;
  top: 40px;
  height: 20px;

  ${small(css`
    height: 30px;
  `)}

  // Target IE11 to make sure logo takes up 100% height.
    @media screen and (-ms-high-contrast: active),
    screen and (-ms-high-contrast: none) {
    height: 100%;
  }
`;

type UnauthenticatedHeaderLogoProps = {
  shouldDisplay: boolean;
};

const UnauthenticatedHeaderLogo = (props: UnauthenticatedHeaderLogoProps) => {
  const { t: translate } = useTranslation('shared');

  if (!props.shouldDisplay) {
    return <></>;
  }

  const isTelus = isTelusTheme();
  const logoSrc = isTelus ? TelusLogo : UnmindLogo;
  const altText = isTelus
    ? `${getChannel().brandName}`
    : translate('navigation.unauthenticated_header_logo.alt_text');

  return <Logo src={logoSrc} alt={altText} />;
};

export default UnauthenticatedHeaderLogo;
